export default __webpack_public_path__ + "static/media/ghost-person.208cf8d0.svg";